module.exports = __webpack_public_path__ + "static/media/birds-song-in-forest.87e1a5d2.mp3";